import { CustomCellRendererProps } from "ag-grid-react";

import "./change_type_renderer.less";

interface ChangeTypeRendererProps {
  props: CustomCellRendererProps;
}

const ChangeTypeRenderer: React.FC<ChangeTypeRendererProps> = ({ props }) => {
  return (
    <div
      className={`change-type-renderer change-type-renderer--${props.value.toLowerCase()}`}
    >
      {props.value}
    </div>
  );
};

export default ChangeTypeRenderer;
